// copy-link.js
;(({ $$ }) => {
    $$('.copy-link').forEach(cp => {
        const link = cp.querySelector('.copy-link__link')
        // const label = cp.querySelector('.copy-link__label')
        const button = cp.querySelector('.copy-link__button')

        if (!link || !button) {
            return
        }

        button.addEventListener('click', e => {
            e.preventDefault()

            // Select the text field
            link.select();
            link.setSelectionRange(0, 99999)
            navigator.clipboard.writeText(link.value)

            // alert(link.value)
        })
    })
})(CNS);